<template>
  <section id="landing-list-icons">
    <header class="landing-default">
      <h3>Więcej niż najem adresu</h3>
    </header>
    <div class="flex">
      <article>
        <i class="material-icons">room</i>
        <h5>Prestiżowy wirtualny adres</h5>
        <h6>Wynajmiesz atrakcyjny adres <br>dla firmy we Wrocławiu<br> - ul. Świeradowska 51-57.</h6>
        <router-link to="wiecej-niz-najem#packet-address">
          <p>Zobacz więcej</p>
          <i class="material-icons">arrow_right_alt</i>
        </router-link>
      </article>
      <article>
        <i class="material-icons">account_balance_wallet</i>
        <h5>Nowoczesne wirtualne biuro</h5>
        <h6>Otrzymasz nowoczesne, jedne<br> z najtańszych i kompleksowych rozwiązań dla biznesu.</h6>
        <router-link to="wiecej-niz-najem#packet-cheap">
          <p>Zobacz więcej</p>
          <i class="material-icons">arrow_right_alt</i>
        </router-link>
      </article>
      <article>
        <i class="material-icons">business</i>
        <h5>Komfortowe powierzchnie</h5>
        <h6>Skorzystasz z doskonale wyposażonych sal konferencyjnych do wynajęcia.</h6>
        <router-link to="wiecej-niz-najem#packet-attractive">
          <p>Zobacz więcej</p>
          <i class="material-icons">arrow_right_alt</i>
        </router-link>
      </article>
      <article>
        <i class="material-icons">devices_other</i>
        <h5>Zdalna obsługa </h5>
        <h6>Docenisz zdalną platformę<br> do zarządzania Twoją firmą.</h6>
        <router-link to="wiecej-niz-najem#packet-remote">
          <p>Zobacz więcej</p>
          <i class="material-icons">arrow_right_alt</i>
        </router-link>
      </article>
      <article>
        <i class="material-icons">contact_mail</i>
        <h5>Bezpłatna wizytówka firmy</h5>
        <h6>Pochwalisz się wynajętym adresem firmy i będziesz mógł ją promować wśród klientów i kontrahentów.</h6>
        <router-link to="wiecej-niz-najem#packet-free">
          <p>Zobacz więcej</p>
          <i class="material-icons">arrow_right_alt</i>
        </router-link>
      </article>
      <article>
        <i class="material-icons">language</i>
        <h5>Obecność w kraju i za granicą</h5>
        <h6>Będziesz mógł prowadzić firmę<br> z każdego miejsca, bo wirtualne biuro zawsze będzie z Tobą.</h6>
        <router-link to="wiecej-niz-najem#packet-country">
          <p>Zobacz więcej</p>
          <i class="material-icons">arrow_right_alt</i>
        </router-link>
      </article>
    </div>
  </section>
</template>

<script>
export default {
  name: 'LandingListIcons',
}
</script>

<style lang="scss">
  section#landing-list-icons { background: #fff; }
  section#landing-list-icons div.flex { display: flex; flex-wrap: wrap; justify-content: center; width: 1380px; margin: 0 auto 50px auto; }
  section#landing-list-icons article { display: flex; flex-direction: column; width: 400px; height: 225px; margin: 30px; border-radius: 10px; background: #fff; 
   overflow: auto; position: relative; border: 2px solid $grayLight; }
  section#landing-list-icons article i.material-icons { display: block; margin: 20px 0 0 0; text-align: center; color: $orangeDark; font-size: 32px; }
  section#landing-list-icons article h5 { margin: 15px 0 15px 0; padding: 0; color: #616161; font-size: 21px; font-weight: 600; text-align: center; }
  section#landing-list-icons article h6 { width: 300px; margin: 0 auto; padding: 0; font-weight: 400; font-size: 14px; color: rgba(0, 0, 0, 0.7); text-align: center; }
  section#landing-list-icons article a { display: flex; justify-content: center; align-items: center; width: 127px; margin: auto auto 15px auto; text-decoration: none; 
    color: #FF6D00; border-bottom: 1px solid #fff; }
  section#landing-list-icons article a i.material-icons { width: 24px; height: 24px; margin: 0 0 0 3px; font-size: 24px; text-decoration: none; color: $orangeLight; }
  section#landing-list-icons article p { display: block; margin: 0; padding: 0; text-align: center; color: #FF6D00; text-decoration: none; font-size: 13px; 
    font-weight: 500; }
  section#landing-list-icons article a:hover { border-bottom: 1px solid #FF6D00; }

  @media (max-width: 1380px) {
    section#landing-list-icons div.flex { width: 980px; }
  }

  @media (max-width: 980px) {
    section#landing-list-icons div.flex { justify-content: center; width: inherit; }
    section#landing-list-icons article { width: 350px; }
  }

  @media (max-width: 405px) {
    section#landing-list-icons article { min-height: 225px; height: inherit; max-height: 270px; }
  }

  @media (max-width: 400px) {
    section#landing-list-icons div.flex { width: 100vw; }
    section#landing-list-icons article { width: 100vw; }
    section#landing-list-icons div.flex article h6 { width: 100%; padding: 0 15px; }
  }
</style>
